module.exports = __webpack_public_path__ + "img/img3.028e8ece.png";